module.exports = __webpack_public_path__ + "static/img/contact_qr_new.cda90a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/contact_qr_new.png
// module id = YhO1
// module chunks = 51